<template lang="pug">
.message-history-family-reply-list.d-flex.flex-column.align-items-stretch
  .message-wrapper.d-flex.flex-column
    .message.d-flex.flex-row.mb-2(v-for="message in _value" @click="onMessage(message)" :class="getReadClass(message)")
      .unread-bar
      .contents.d-flex.align-items-center
        .d-flex.flex-column.flex-grow-1.mr-2(v-if="message.type == 'error'")
          .d-flex.flex-row
            .name.d-flex.flex-column.flex-grow-1
              span.error-badge.badge.badge-pill.badge-danger !
              span.main-name {{ message.mainName }}
              span {{ message.subTitle }}
            .date.d-flex.flex-row.align-items-start.justify-content-end
              span.datetime {{ convertDate(message.datetime) }}
        .d-flex.flex-column.flex-grow-1.mr-2(v-else)
          .d-flex.flex-row
            .name.d-flex.flex-column.flex-grow-1
              span.main-name {{ message.mainName }}
              span {{ message.subTitle }}
            .date.d-flex.flex-column.align-items-start
              span.datetime {{ convertDate(message.datetime) }}
              .confirm-switch.d-flex.flex-row.justify-content-end
                ConfirmStatusSwitch(v-model="message.readed" @onSwitch="onSwitch(message)")
        .d-flex.svg-icon
          .angle-right

  Loading(:isBusy="isBusy")
</template>

<script lang="ts">
import { Component, Prop, Vue } from "vue-property-decorator";

import ConfirmStatusSwitch from "@/mobile/basics/ConfirmStatusSwitch.vue";
import Loading from "@/mobile/basics/Loading.vue";
import { ReceiverDetail } from "@/commons/models/SendLineMessage";

/**
 * ### メッセージ履歴返信リスト
 */
@Component({
  components: {
    ConfirmStatusSwitch,
    Loading
  }
})
export default class MessageHistoryReplyList extends Vue {
  /** 表示対象のメッセージ */
  @Prop({
    required: true
  })
  value!: Array<MessageHistoryReplyListItem>;
  /** 読込み中の表示可否 */
  @Prop({
    required: true
  })
  isBusy!: boolean;

  get _value(): Array<MessageHistoryReplyListItem> {
    return this.value;
  }

  /**
   * ### メッセージクリックイベント
   *
   * - 未読であれば未読を既読に変更し、親コンポーネントに既読にしたことを通知する
   * - 返信リストの未読件数を減算する
   */
  public onMessage(message: MessageHistoryReplyListItem): void {
    this.$emit("onMessage", message);
    return;
  }

  public onSwitch(message: MessageHistoryReplyListItem): void {
    this.$emit("onReadSwitch", message);
    return;
  }

  /**
   * ### 返信メッセージの未読/既読用のCssクラスを返す
   */
  public getReadClass(message: MessageHistoryReplyListItem): string {
    if (message.readed == false) {
      if (message.type == MessageHistoryReplyListType.REPLY) {
        return "unread";
      } else if (message.type == MessageHistoryReplyListType.ERROR) {
        return "error-unread";
      }
    }
    return "";
  }

  /**
   * ### 数値の日付を文字列に変換する
   */
  public convertDate(datetime: number | null): string {
    return datetime ? this.$dateUtil.convertNumberToString(datetime, "mm月dd日 hh:MM") : "";
  }
}

/** テーブルの1行あたりの情報 */
export interface MessageHistoryReplyListItem {
  parentMessagesSortKey: string;
  residentId?: number;
  familyId?: number;
  groupId?: number;
  memberId?: number;

  isSharedMessages: boolean;
  receiverDetails: Array<ReceiverDetail>;
  mainName: string;
  subTitle: string;
  subName: string;
  datetime: number | null;
  readed: boolean;
  type: MessageHistoryReplyListType;
  messages: Array<any>;
}

export enum MessageHistoryReplyListType {
  REPLY = "reply",
  ERROR = "error"
}
</script>

<style lang="scss" scoped>
@import "../../../styles/mobile/_mixin.scss";
@import "../../../styles/mobile/_colors.scss";

.message-history-family-reply-list {
  position: relative;
  overflow-y: auto;
  overflow-x: auto;

  .svg-icon {
    width: 16px;
    height: 16px;
    margin-left: -6px;
    .angle-right {
      @include svg-icon("../../../assets/angle-right.svg", $font-base, 18px, 18px);
    }
  }

  // 返信メッセージ
  .message {
    min-height: 50px;
    border-bottom: solid 1px $border-default;

    &:last-child {
      border-bottom: 0;
    }

    // 未読
    .unread-bar {
      margin-right: 0.5rem;
    }

    .contents {
      width: 100%;
      .main-name {
        font-weight: bold;
      }
      .date {
        min-width: 110px;
        font-size: 14px;
      }
      .date {
        .confirm-switch {
          width: 100%;
        }
      }
    }
  }
  .message:nth-child(2n) {
    background-color: $bg-striped;
  }

  // 未読の返信メッセージを強調するスタイル
  .unread {
    // リンクであることが分かるようにカーソルを変える
    cursor: pointer;
    .unread-bar {
      display: block;
      width: 4px;
      background-color: $font-key;
    }

    .contents {
      .name,
      .date {
        color: $font-key;
      }
      .name,
      .date {
        font-weight: bold;
      }
    }
  }
  // 未読の返信メッセージ(エラー)を強調するスタイル
  .error-unread {
    // リンクであることが分かるようにカーソルを変える
    cursor: pointer;
    .unread-bar {
      display: block;
      width: 4px;
      background-color: $font-strong;
    }

    .contents {
      .name,
      .date {
        color: $font-strong;
      }
      .name,
      .date {
        font-weight: bold;
      }
    }
  }
  .error-badge {
    margin: 0 8px 2px 0;
  }
}
</style>
